const isArray = require('./isArray');

const isArrayNotEmpty = arrayValue => {
  return isArray(arrayValue) && arrayValue.length > 0;
};

module.exports = isArrayNotEmpty;
